<template>
    <div>
        <el-dialog title="专属教服" :visible.sync="educateVisible" class="new_bac" :before-close="educateClose">
            <div class="educateWrap">
                <div class="serve">
                    <div class="title">
                        <div class="color-FF5E51"></div>
                        <span>专属服务</span>
                    </div>
                    <div class="main">
                        <div v-show="jfType.length > 0" class="mainItam" v-for="item in jfType" :key="item">
                            <img v-if="item == '1'" class="mainItamIcon"
                                src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Home/notice.png" />
                            <img v-if="item == '2'" class="mainItamIcon"
                                src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Home/track.png" />
                            <img v-if="item == '3'" class="mainItamIcon"
                                src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Home/regular.png" />
                            <img v-if="item == '4'" class="mainItamIcon"
                                src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Home/answer.png" />
                            <span>{{ item==1?'考试通知':item==2?'督学跟踪':item==3?'定期班会':item==4?'在线答疑':'' }}</span>
                        </div>
                    </div>
                </div>
                <div class="details">
                    <div class="title">
                        <div class="color-FF5E51"></div>
                        <span>教服详情</span>
                    </div>
                    <div v-html="ImgSizeLimit(jfServer)"></div>
                </div>
                <!-- <div class="classMeeting">
                    <div class="title">
                        <div class="color-FF5E51"></div>
                        <span>班会</span>
                    </div>
                    <div class="main">
                        <div 
                            class="mainItem" 
                            v-for="item,index in classMeetingList"
                            :key="index"
                        >
                            <div class="mainItemTitle" v-if="item.index == 1">
                                <img class="img" src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/kecheng/Group1339.png"/>
                                <span >正在直播中</span>
                            </div>
                            <div class="mainItemTitle" v-if="item.index == 2">
                                <span >距直播开始：</span>
                                <div class="block">02</div>
                                <span>：</span>
                                <div class="block">24</div>
                                <span>：</span>
                                <div class="block">32</div>
                            </div>
                            <div class="mainItemTitle" v-if="item.index == 3">
                                <span >距直播开始：</span>
                                <div class="block">02</div>
                                <span>：</span>
                                <div class="block">24</div>
                                <span>：</span>
                                <div class="block">32</div>
                                <div class="right">
                                    <span>
                                        预约成功
                                    </span>
                                </div>
                            </div>
                            <div class="mainItemTitle" v-if="item.index == 4">
                                <span >直播已结束</span>
                            </div>

                            <div class="contentItem">
                                <el-image class="image"></el-image>
                                <div class="contentMain">
                                    <div class="contentText">
                                        <div class="contentTitle">{{item.value}}</div>
                                        <div class="contentTime">{{`直播时间：${item.time}`}}</div>
                                    </div>
                                    <div class="contentBtn">
                                        <span>{{ `${item.people}人预约` }}</span>
                                        <el-button class="btn" size="mini" type="danger" v-if="item.index == 1">立即观看</el-button>
                                        <el-button class="btn" size="mini" type="danger" v-else-if="item.index == 2">立即预约</el-button>
                                        <el-button class="btn" size="mini" type="info" v-else-if="item.index == 3" disabled>立即观看</el-button>
                                        <el-button class="btn" size="mini" v-else>观看回放</el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <!-- <div class="seven-title">
                    <img src="@/assets/coachCourse/left.png" />
                    <span>七大服务</span>
                    <img src="@/assets/coachCourse/right.png" />
                </div>
                <div class="seven-main">
                    <div class="seven-item" v-for="(item, index) in sevenList" :key="index">
                        <img :src="item.img" class="seven-item-img" />
                        <div class="seven-item-title">{{ item.name }}</div>
                    </div>
                    <div class="seven-line"></div>
                </div> -->
            </div>

            <span slot="footer" class="dialog-footer">
                <!-- <el-button @click="educateClose" size="mini">关闭</el-button> -->
                <!-- <el-button type="primary" @click="dialogVisible = false" size="mini">确 定</el-button> -->
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
    props: ['educateVisible'],
    data() {
        return {
            classMeetingList: [
                { index: 1, value: '2021年元宇宙概念班会-第二期', time: '2021-12-10 12:30', people: 3000 },
                { index: 2, value: '2021年元宇宙概念班会-第二期', time: '2021-12-10 12:30', people: 3000 },
                { index: 3, value: '2021年元宇宙概念班会', time: '2021-12-10 12:30', people: 3000 },
                { index: 4, value: '2021年元宇宙概念班会', time: '2021-12-10 12:30', people: 3000 }
            ],
            jfServer: null,
            jfType: [],
            sevenList: [
                {
                    img: require("@/assets/coachCourse/icon-01.png"),
                    name: "考试通知",
                },
                {
                    img: require("@/assets/coachCourse/icon-02.png"),
                    name: "督学跟踪",
                },
                {
                    img: require("@/assets/coachCourse/icon-03.png"),
                    name: "定期班会",
                },
                {
                    img: require("@/assets/coachCourse/icon-04.png"),
                    name: "在线答疑",
                },
                {
                    img: require("@/assets/coachCourse/icon-05.png"),
                    name: "学习资料",
                },
                {
                    img: require("@/assets/coachCourse/icon-06.png"),
                    name: "报考指导",
                },
                {
                    img: require("@/assets/coachCourse/icon-07.png"),
                    name: "学习指导",
                },
            ]
        }

    },
    methods: {
        init(jfServer, detalilsList) {
            console.log(detalilsList,'detalilsList')
            homeClient.qbsCoachClassTypeClassMeeting(detalilsList.coachClassTypeId).then(res => {
                if (res.code == 0) {
                    // this.classMeetingList = res.msg
                    this.jfServer = res.data.rows.introduce
                    this.jfType = res.data.rows.classMeetingService.split(',')
                }
            })
            // this.jfServer = jfServer
            // this.jfType = detalilsList.jfType.split(',')
        },
        /* 关闭回调 */
        educateClose() {
            this.$emit('educateClose')
        }
    }
}
</script>

<style lang="less" scoped>
.educateWrap {
    width: 680px;
    height: 419px;
    background: #ffffff;
    border-radius: 20px 20px 20px 20px;
    margin: 0 auto;
    margin-top: 15px;
    padding: 20px;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;

    .serve {
        margin-bottom: 20px;

        .main {
            display: flex;

            /* justify-content: space-between; */
            .mainItam {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 19px;
                /* text-align: center; */
                /* line-height: 80px; */
                width: 186px;
                height: 80px;
                background-color: #f5f7f9;
                font-size: 18px;
                font-family: Microsoft YaHei-Regular;
                border-radius: 8px;

                .mainItamIcon {
                    width: 24px;
                    height: 24px;
                }
            }
        }
    }

    .title {
        display: flex;
        align-items: center;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        margin-bottom: 20px;

        .color-FF5E51 {
            background-color: #ff5e51;
            width: 3px;
            height: 14px;
            margin-right: 8px;
        }
    }

    .details {
        margin-bottom: 32px;

        .image {
            width: 596px;
            height: 242px;
            border-radius: 8px;
        }
    }

    .classMeeting {
        .main {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            .mainItem {
                width: 596px;
                height: 156px;
                background-color: #eeeeee;
                border-radius: 8px;
                margin-bottom: 24px;
                padding: 18px 16px 0 16px;

                .mainItemTitle {
                    display: flex;
                    align-items: center;
                    margin-bottom: 15px;
                    color: #6c7079;
                    font-size: 14px;
                    font-family: PingFang SC-Regular, PingFang SC;

                    .img {
                        margin-right: 4px;
                    }

                    .block {
                        width: 16px;
                        height: 16px;
                        background-color: #ff5e51;
                        color: #ffffff;
                        font-size: 10px;
                        line-height: 16px;
                        text-align: center;
                        border-radius: 2px;
                    }

                    .right {
                        margin-left: 156px;
                        font-size: 12px;
                        color: #ff5e51;
                    }
                }

                .contentItem {
                    display: flex;

                    .image {
                        width: 138px;
                        height: 92px;
                        border-radius: 8px;
                        margin-right: 12px;
                    }

                    .contentMain {
                        display: flex;
                        flex-direction: column;

                        .contentText {
                            margin-bottom: 22px;

                            .contentTitle {
                                font-size: 14px;
                                font-weight: 500;
                                color: #373a42;
                                margin-bottom: 12px;
                            }

                            .contentTime {
                                font-size: 12px;
                                color: #6c7079;
                            }
                        }

                        .contentBtn {
                            font-size: 12px;
                            color: #9fa4ad;
                            display: flex;
                            align-items: center;

                            .btn {
                                margin-left: 269px;
                            }
                        }
                    }
                }
            }
        }
    }
}

::v-deep .new_bac {
    .el-dialog {
        background: url(https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/study/1.png);
        background-size: 100% 100%;
        border-radius: 20px !important;
        width: 690px;
        height: 494px;

        .el-dialog__title {
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 22px;
            color: #1d315b;
        }

        .el-dialog__close {
            font-size: 23px;
        }

        .el-dialog__body {
            padding: 0px !important;
        }
    }
}

.seven-title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #3a3d4b;
    font-weight: bold;
    margin-top: 8px;

    img {
        width: 156px;
        height: 15px;
    }

    span {
        margin: 0 12px;
    }
}

.seven-main {
    display: flex;
    justify-content: space-between;
    margin-top: 23px;
    padding: 0 4px;
    position: relative;

    .seven-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        z-index: 2;

        .seven-item-img {
            width: 68px;
            height: 95px;
        }

        .seven-item-title {
            font-size: 12px;
            color: #333;
            font-weight: 600;
            padding: 4px 14px;
            border: 1px solid #247cff;
            border-radius: 21px;
        }
    }

    .seven-line {
        border-top: 1px dashed #ddd;
        width: 90%;
        position: absolute;
        bottom: 43px;
        left: 50%;
        transform: translateX(-50%);
    }
}
</style>
